import 'css/shared/_toast.scss';

import 'jquery-toast-plugin';
import 'js/plugin/brickwall/brickwall.jquery.js';

;(function($, window, document, undefined) {

  const pluginName = 'formHandler';

  class FormHandler {

    constructor(element, options) {

      this._name = pluginName;
      this._defaults = $.fn[pluginName].defaults;

      this.element = element;
      this.options = $.extend(true, {}, this._defaults, options);

      this.init();

    }

    init() {
      this.cacheElements();
      this.bindEvents();

      this.$element.brickwall();
    }

    cacheElements() {
      this.$element = $(this.element);
    }

    bindEvents() {
      this.$element.on('submit', this.handler.bind(this));
      this.$element.on('keypress', 'input', this.clearValidation);
      this.$element.on('keypress', 'textarea', this.clearValidation);
    }

    clearValidation() {

      $(this)
        .removeClass('invalid')
        .siblings('label')
        .removeAttr('data-error');

      $(this)
        .siblings('.error')
        .text('');

    }

    handler(event) {
      event.preventDefault();

      var $element = this.$element;

      var ajaxDefaultOptions = {
        url: $element.attr("action"),
        type: $element.attr("method"),
        data:  $element.serialize(),
        beforeSend: function() {
          $element.brickwall("up");
        },
        complete: function() {
          $element.brickwall("down");
        }
      };

      var ajaxConfig = $.extend(ajaxDefaultOptions, this.options.ajaxOptions);

      $.ajax(ajaxConfig);
    }

  }

  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, `plugin_${pluginName}`)) {
        $.data(this, `plugin_${pluginName}`, new FormHandler(this, options));
      }
    });
  };

  $.fn[pluginName].defaults = {
    ajaxOptions: {
      dataType: 'json',
      success: function(data) {

        if (data.redirect) {
          window.location = data.redirect;
          return;
        }

        $.toast({
          hideAfter: 5000,
          heading: data.message.title,
          text: data.message.text,
          position: 'bottom-center',
          icon: data.message.type
        });

      },
      error: function(jqXHR) {

        var error = jqXHR.responseJSON;

        if (error.message) {
          $.toast({
            hideAfter: 5000,
            heading: error.message.title,
            text: error.message.text,
            position: 'bottom-center',
            icon: error.message.type
          });
        }

        if (error.fields) {
          $.map(error.fields, function(msg, field) {

            $(`#${field}`)
              .addClass('invalid')
              .siblings('label')
              .attr('data-error', msg);

            $(`#${field}`)
              .siblings('.error')
              .text(msg);

          });
        }


      }
    }
  };


})(jQuery, window, document);
